<template>
    <div class="accordion">
        <button
          type="button" aria-label="expand" class="accordion__button" :class="{active: isActive}"
          @click="toggleSlide($event)"
        >
          {{headerText}}
        </button>
        <div class="accordion__panel">
            <slot>default content here</slot>
        </div>
    </div>
</template>

<script>
// require jquery
const $ = require('jquery')
window.$ = $

export default {
  props: {
    imgSrc: String,
    headerText: String,
    isActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    toggleSlide (e) {
      // console.log($(e.target).parent().find('.accordion__panel'))
      $(e.target).parent().find('.accordion__panel').slideToggle('fast')
      $(e.target).toggleClass('active')

      // emit completed
      this.$emit('opened')
    }
  },
  mounted () {
    // ACCORDIONS
    const panel = $(this.$el).find('.accordion__panel')
    if (this.isActive) {
      panel.show()
    } else {
      panel.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #CREATIVE CONCEPT PRIMARY COLOURS
\*------------------------------------*/
$burgundy: #5D0819;
$accordion-color: #666;
$teal: #8BC7CD;
$light-grey: #E7E7E7;

@import '../styles/colors';

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/

  /**
  * ACCORDION
  */

  .accordion {
    &__document {
        display: block;
        margin: 2rem auto;
        max-width: 300px;
    }

    &__icon {
        margin: -1rem 20px;
        display: inline-block;
        width: 50px;
    }

    &__img {
      display: block;
      margin: 0rem auto 2rem;
    }

    &__thumb {
      display: block;
      margin: 0rem auto 2rem;
      height: 200px;
    }
  }
  .accordion__button {
    // background-color: $accordion-color;
    // color: #fff;
    cursor: pointer;
    padding: 18px;
    padding-right: 50px;
    width: 100%;
    // text-align: left;
    transition: max-height 0.4s;
    // border: 1px solid #cccccc;
    // font-weight: 700;
    // border-left: 5px solid $gac-dark-blue;

    // Make full width *mobile only
    width: 100vw;
    position: relative;
    left: 50%;
    margin-left: -50vw;

    &:after {
        // content: url('../assets/img/_nav/down-chevron.png');
        color: #fff;
        font-weight: bold;
        // float: right;
        position: absolute;
        right: 15px;
        top: 18px;
        transition: all 0.2s ease;
    }
  }

  .accordion__panel {
    padding: 1em 15px;
    // background-color: #fff;
    transition: max-height 0.2s ease-out;
    margin-bottom: 0px;
    // border: 1px solid #eee;

    // Make full width *mobile only
    width: 100vw;
    position: relative;
    left: 50%;
    margin-left: -50vw;
  }

  .active:after {
    // content: url('../assets/img/_nav/down-chevron.png');
    transform: rotate(45deg);
    right: 5px;
    top: 20px;
  }

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width:768px) {
    /**
    * ACCORDION
    */
    .accordion__button {
        // Make full width *mobile only
        width: 100%;
        position: relative;
        left: 0%;
        margin-left: 0vw;
    }

    .accordion__panel {
        // Make full width *mobile only
        width: 100%;
        position: relative;
        left: 0%;
        margin-left: 0vw;
        // background-color: $light-grey
    }
  }
/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width:992px) {

}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width:1200px) {

}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width:1320px) {

}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width:1600px) {

}
</style>
